import { useTranslation } from 'react-i18next';
import { Button } from '@sendible/design-system/src';
import { ReportDropdownMenu } from '../ReportDropdownMenu';
import { HeaderRight as ReportHeaderRight, EditingLabel, HeaderDivider, HeaderMenuWrapper } from '../../index.styles';

type HeaderActionsProps = {
  isEditing: boolean;
  isSaving: boolean;
  isDirty: boolean;
  saveLabel: string;
  menuRef: React.RefObject<HTMLDivElement | null>;
  isMenuOpen: boolean;
  onEdit: () => void;
  onCancelEdit: () => void;
  onSave: () => void;
  onToggleMenu: () => void;
  onCloseMenu: () => void;
  onDuplicate: () => void;
  onClose: () => void;
  onDelete: () => void;
};

export const HeaderActions = ({
  isEditing,
  isSaving,
  isDirty,
  saveLabel,
  menuRef,
  isMenuOpen,
  onEdit,
  onCancelEdit,
  onSave,
  onToggleMenu,
  onCloseMenu,
  onDuplicate,
  onClose,
  onDelete,
}: HeaderActionsProps) => {
  const { t } = useTranslation('reports');

  if (isEditing) {
    return (
      <ReportHeaderRight>
        <EditingLabel data-testid="report-editing-label">{t('new_reports_currently_editing')}</EditingLabel>
        <Button
          appearance="default"
          size={12}
          label={t('new_reports_cancel') as string}
          onClick={onCancelEdit}
          data-testid="report-cancel-button"
        />
        <Button
          appearance="primary"
          variation="fill"
          size={12}
          label={saveLabel}
          disabled={isSaving || !isDirty}
          onClick={onSave}
          data-testid="report-save-button"
        />
      </ReportHeaderRight>
    );
  }

  return (
    <ReportHeaderRight>
      <Button
        appearance="primary"
        variation="fill"
        size={12}
        icon="edit_alt"
        label={t('new_reports_edit') as string}
        onClick={onEdit}
        data-testid="report-edit-button"
      />
      <HeaderDivider />
      <HeaderMenuWrapper ref={menuRef}>
        <Button
          icon="more_vertical"
          aria-label={t('new_reports_more_options') as string}
          onClick={onToggleMenu}
        />
        {isMenuOpen && (
          <ReportDropdownMenu
            onDuplicate={() => {
              onCloseMenu();
              onDuplicate();
            }}
            onClose={() => {
              onCloseMenu();
              onClose();
            }}
            onDelete={() => {
              onCloseMenu();
              onDelete();
            }}
          />
        )}
      </HeaderMenuWrapper>
    </ReportHeaderRight>
  );
};
